import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option:
      "a) complementar o trabalho de campo, reforçando os benefícios e mensagens chave dos tratamentos fornecidos pela Boehringer exclusivamente aos médicos por diferentes canais de comunicação",
    correct: false,
  },
  {
    option:
      "b) promover “disease awareness” para que o máximo de pessoas tenham conhecimento sobre determinada doença",
    correct: false,
  },
  {
    option:
      "c) auxiliar a gerar tráfego de médicos aos eventos fornecidos pela Boehringer, sejam eles presenciais ou remotos",
    correct: false,
  },
  {
    option:
      "d) promover novas formas de comunicação com nossos clientes, através de, por exemplo, redes sociais",
    correct: false,
  },
  {
    option: "e) todas as alternativas anteriores",
    correct: true,
  },
];

export default function Question6(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question6: {
          title: "Marketing Digital serve para:",
          option: option.option,
          correct: option.correct,
        },
      };
    });
  }
  return (
    <div className="div-question">
      <h5 style={{ textAlign: "center" }}>Marketing Digital serve para:</h5>

      <div className="div-options-question-boe">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-boe ${
              optionSelected === e.option && "selected-option-question-boe"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
